// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text, Tooltip } from '@mantine/core';
import { i18n } from '@lingui/core';
import { openModal } from '@mantine/modals';
import { IconMailFast, IconBackspace } from '@tabler/icons';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { RecommendationContext } from './RecommendationsPane';
import CheckAllAvailabilityModal from './Modals/CheckAllAvailabilityModal';
import RecommendationsDeleteModal from './Modals/RecommendationsDeleteModal';

const RecommendationsActions = () => {
  const { recommendations, reload, removeAll } = useContext(RecommendationContext);
  const { id: eventId } = useParams();
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  // Use only recommendations, which weren't requested yet
  const filteredRecommendations = recommendations.filter((recommendation) => !recommendation.lastRequested);
  const { length } = filteredRecommendations;
  const isEmpty = length === 0;

  const openQueryAvailabilityModal = () =>
    openModal({
      size: 550,
      title: (
        <Text weight="bolder" size="lg" sx={{ lineHeight: 1.2 }}>
          {i18n._('recommendation.request.submit.head')}
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      children: (
        <CheckAllAvailabilityModal
          recommendations={filteredRecommendations}
          reload={reload}
          eventId={Number(eventId)}
          executeWithLicenceCheck={executeWithLicenceCheck}
        />
      ),
    });

  const openDeleteModal = () => {
    if (eventId) {
      openModal({
        size: 550,
        title: (
          <Text weight="bolder" size="lg" sx={{ lineHeight: 1.2 }}>
            {i18n._('event.recommendations.delete.confirm.head')}
          </Text>
        ),
        closeOnEscape: true,
        transition: 'slide-down',
        children: (
          <RecommendationsDeleteModal
            eventId={Number(eventId)}
            removeAllRecommendations={removeAll}
            executeWithLicenceCheck={executeWithLicenceCheck}
          />
        ),
      });
    }
  };

  return (
    <Group
      p={5}
      position="center"
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.secondaryBlue[0],
        color: theme.colorScheme === 'dark' ? 'white' : theme.colors.blue[3],
        borderRadius: theme.radius.md,
        fontSize: theme.fontSizes.xs,
      })}
    >
      <Tooltip
        withArrow
        multiline
        disabled={!isEmpty}
        transition="slide-down"
        position="bottom"
        width={235}
        label=" Alle Dienstleister wurden bereits nach ihrer verfügbarkeit gefragt."
      >
        <Text
          sx={{ cursor: isEmpty ? 'default' : 'pointer', opacity: isEmpty ? 0.5 : 1 }}
          onClick={openQueryAvailabilityModal}
        >
          <IconMailFast size={16} /> Alle anfragen
        </Text>
      </Tooltip>
      <Text sx={{ cursor: 'pointer' }} onClick={openDeleteModal}>
        <IconBackspace size={16} />
        {'  '}
        Alle entfernen
      </Text>
    </Group>
  );
};

export default RecommendationsActions;
